var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.5C11.8869 18.5 14.1761 17.5518 15.864 15.864C17.5518 14.1761 18.5 11.8869 18.5 9.5C18.5 7.11305 17.5518 4.82387 15.864 3.13604C14.1761 1.44821 11.8869 0.5 9.5 0.5C7.11305 0.5 4.82387 1.44821 3.13604 3.13604C1.44821 4.82387 0.5 7.11305 0.5 9.5C0.5 11.8869 1.44821 14.1761 3.13604 15.864C4.82387 17.5518 7.11305 18.5 9.5 18.5ZM13.4727 7.84766L8.97266 12.3477C8.64219 12.6781 8.10781 12.6781 7.78086 12.3477L5.53086 10.0977C5.20039 9.76719 5.20039 9.23281 5.53086 8.90586C5.86133 8.57891 6.3957 8.57539 6.72266 8.90586L8.375 10.5582L12.2773 6.65234C12.6078 6.32188 13.1422 6.32188 13.4691 6.65234C13.7961 6.98281 13.7996 7.51719 13.4691 7.84414L13.4727 7.84766Z",
    fill: "#209CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.68bbdf35355760de969d0f0d12d0ec46.svg";
export { ForwardRef as ReactComponent };